import React from "react";
import {Contactsec1} from './components/Contactcomponent';
import PageHeader from "./components/PagesHeaderComponent/PageHeader";

const Contact = () => {
  return (
    <>
      <div id="contact_main">
        <PageHeader heading="Contact" />
        <div className="content_wrap">
          <Contactsec1 />
        </div>
      </div>
    </>
  );
};

export default Contact;